/**
 * Application Layout Component
 * Main layout wrapper for the application
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../common/ErrorBoundary';
import { useAuth } from '../../hooks/useAuth';
import ProfessionalLoader from '../common/ProfessionalLoader';
import './AppLayout.css';

const AppLayout = () => {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="app-loading">
        <ProfessionalLoader size="large" variant="default" />
        <p>Loading application...</p>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="app-layout">
        <Outlet />
      </div>
    </ErrorBoundary>
  );
};

export default AppLayout;
